export default __webpack_public_path__ + "static/media/330_business05-jp-mobile.d8f2564d.png";